import { fieldEmail, fieldEmailOptional } from '../validators/fieldEmail'
import { fieldNumber, fieldNumberOptional } from '../validators/fieldNumber'
import { fieldString, fieldStringOptional } from '../validators/fieldString'

type Props = {
	requiredMessage: string
	invalidNumberMessage: string
	invalidEmailMessage: string
}

export const getTranslatedValidation = ({ requiredMessage, invalidEmailMessage, invalidNumberMessage }: Props) => ({
	fieldEmail: () => fieldEmail({ requiredErrorMessage: requiredMessage, invalidErrorMessage: invalidEmailMessage }),
	fieldNumber: () => fieldNumber({ requiredErrorMessage: requiredMessage, invalidErrorMessage: invalidNumberMessage }),
	fieldString: () => fieldString({ requiredErrorMessage: requiredMessage }),

	fieldEmailOptional: () => fieldEmailOptional({ invalidErrorMessage: invalidEmailMessage }),
	fieldNumberOptional: () => fieldNumberOptional({ invalidErrorMessage: invalidNumberMessage }),
	fieldStringOptional: () => fieldStringOptional(),
})
